@if(printerFormService.printerFormReady() && printer && options) {
    <app-card 
        [fullWidth]="!showGeneralCard"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.HEADER' | translate"
    >
        <section class="tw-grid tw-grid-cols-1 tw-gap-y-4 tw-p-1 tw-pb-2">
            @for(ln of headerLineNumbers; track ln) {
                @if(options['header' + ln]) {
                    <div class="tw-flex tw-flex-col tw-gap-y-4 tw-border-b tw-border-gray-100 last:tw-border-0 md:tw-border-0">
                        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-2">
                            <div class="tw-col-span-12 md:tw-col-span-2">
                                <span [class]="subTitleClass">
                                    {{ 'PRINTERS.DETAIL.ROW' | translate }} {{ ln }}
                                </span>
                            </div>
                            <div class="tw-col-span-12 md:tw-col-span-10">
                                <span [class]="linearValueClass">
                                    {{ options['header' + ln] || '-' }}
                                </span>
                            </div>
                        </div>
                    </div>
                }
            }
        </section>
    </app-card>

    @if(showGeneralCard) {
        <app-card
            [fullWidth]="false"
            [withCard]="true"
            [cardTitle]="'PRINTERS.GENERAL.GENERAL_SECTION' | translate"
        >
            <section class="tw-grid tw-grid-cols-1 tw-gap-y-4 tw-p-1 tw-pb-2">
                <div class="tw-flex tw-flex-col tw-gap-y-4 tw-border-b tw-border-gray-100 last:tw-border-0 md:tw-border-0">
                    @if(printer.printer_number) {
                        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-2">
                            <div class="tw-col-span-12 md:tw-col-span-4 tw-pr-4">
                                <span [class]="subTitleClass">
                                    {{ 'PRINTERS.DETAIL.PRINTER_NUMBER_LIST' | translate }}
                                </span>
                            </div>
                            <div class="tw-col-span-12 md:tw-col-span-8">
                                <span [class]="linearValueClass">
                                    {{ printer.printer_number }}
                                </span>
                            </div>
                        </section>
                    }
                    @if(printerFormService.displayMessage.value) {
                        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-2">
                            <div class="tw-col-span-12 md:tw-col-span-4 tw-pr-4">
                                <span [class]="subTitleClass">
                                    {{ 'PRINTERS.DETAIL.DISPLAY_MESSAGE' | translate }}
                                </span>
                            </div>
                            <div class="tw-col-span-12 md:tw-col-span-8">
                                <span [class]="linearValueClass">
                                    {{ printerFormService.displayMessage.value }}
                                </span>
                            </div>
                        </section>
                    }
                    @if(printerFormService.sellerPrefix.value) {
                        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-2">
                            <div class="tw-col-span-12 md:tw-col-span-4 tw-pr-4">
                                <span [class]="subTitleClass">
                                    {{ 'PRINTERS.GENERAL.SELLER_PREFIX' | translate }}
                                </span>
                            </div>
                            <div class="tw-col-span-12 md:tw-col-span-8">
                                <span [class]="linearValueClass">
                                    {{ printerFormService.sellerPrefix.value }}
                                </span>
                            </div>
                        </section>
                    }
                    @if(printerFormService.tail.value) {
                        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-2">
                            <div class="tw-col-span-12 md:tw-col-span-4 tw-pr-4">
                                <span [class]="subTitleClass">
                                    {{ 'PRINTERS.GENERAL.TAIL' | translate }}
                                </span>
                            </div>
                            <div class="tw-col-span-12 md:tw-col-span-8">
                                <span [class]="linearValueClass">
                                    {{ printerFormService.tail.value }}
                                </span>
                            </div>
                        </section>
                    }
                    @if(printerFormService.qrCodeMessage.value) {
                        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-2">
                            <div class="tw-col-span-12 md:tw-col-span-4 tw-pr-4">
                                <span [class]="subTitleClass">
                                    {{ 'PRINTERS.GENERAL.QR_MESSAGE' | translate }}
                                </span>
                            </div>
                            <div class="tw-col-span-12 md:tw-col-span-8">
                                <span [class]="linearValueClass">
                                    {{ printerFormService.qrCodeMessage.value }}
                                </span>
                            </div>
                        </section>
                    }
                    @if(printerFormService.qrCodeUrl.value) {
                        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-2">
                            <div class="tw-col-span-12 md:tw-col-span-4 tw-pr-4">
                                <span [class]="subTitleClass">
                                    {{ 'PRINTERS.GENERAL.QR_URL' | translate }}
                                </span>
                            </div>
                            <div class="tw-col-span-12 md:tw-col-span-8">
                                <span [class]="linearValueClass">
                                    {{ printerFormService.qrCodeUrl.value }}
                                </span>
                            </div>
                        </section>
                    }
                </div>
            </section>
        </app-card>
    }

    <app-card 
        [fullWidth]="false"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.VATS' | translate"
    >
        <section class="tw-p-1">
            <div class="table-header-sticky">
                <div class="tw-grid tw-grid-cols-[2fr_4.5fr_3.5fr] tw-items-end tw-gap-x-3 tw-gap-y-2">
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.ID</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.VALUE</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.CODE</div>
                </div>

                <div class="tw-col-span-full tw-bg-gray-300 tw-h-px tw-mt-2"></div>
            </div>

            <div class="tw-flex tw-flex-col tw-gap-1">
                @for(vatOne of vats; track vatOne.id; let isEven = $even) {
                    <div class="tw-grid tw-grid-cols-[2fr_4.5fr_3.5fr] tw-items-center tw-rounded tw-gap-x-3 tw-py-2"
                        [class.tw-bg-[var(--sys-input-fill)]]="!isEven">
                        <div [class]="linearValueClass" class="break-words-auto">{{ vatOne.id }}</div>
                        <div [class]="linearValueClass" class="break-words-auto">{{ vatOne.value }}%</div>
                        <div [class]="linearValueClass" class="break-words-auto">{{ vatOne.code || '-' }}</div>
                    </div>
                }
            </div>
        </section>
    </app-card>

    <app-card 
        [fullWidth]="false"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.DEPARTMENTS' | translate"
    >
        <section class="tw-p-1">
            <div class="table-header-sticky">
                <div class="tw-grid tw-grid-cols-[1fr_4.5fr_2.5fr_2fr] tw-items-end tw-gap-x-3 tw-gap-y-2">
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.ID</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.NAME</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.VAT_NUMBER</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.VAT_VALUE</div>
                </div>

                <div class="tw-col-span-full tw-bg-gray-300 tw-h-px tw-mt-2"></div>
            </div>
    
            <div class="tw-flex tw-flex-col tw-gap-1">
                @for(department of departments; track department.id; let isEven = $even) {
                    <div class="tw-grid tw-grid-cols-[1fr_4.5fr_2.5fr_2fr] tw-items-center tw-rounded tw-gap-x-3 tw-py-2"
                        [class.tw-bg-[var(--sys-input-fill)]]="!isEven">
                        <div [class]="linearValueClass" class="break-words-auto">{{ department.id }}</div>
                        <div [class]="linearValueClass" class="break-words-auto">{{ department.name }}</div>
                        <div [class]="linearValueClass" class="break-words-auto">{{ department.vat_id }}</div>
                        <div [class]="linearValueClass" class="break-words-auto">{{ department.vat?.value || '-' }}
                            @if(department.vat?.value) {
                                <span>%</span>
                            }
                        </div>
                    </div>
                }
            </div>
        </section>
    </app-card>

    <app-card 
        [fullWidth]="true"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.PAYMENT_METHODS' | translate"
    >
        <section class="tw-p-1">
            <div class="table-header-sticky">
                <div class="tw-grid tw-grid-cols-[1fr_3.5fr_1fr_1fr_2fr_1.5fr] tw-items-end tw-gap-x-3 tw-gap-y-2">
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.ID</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.NAME</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.TYPE</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.UNCLAIMED</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.BUNDLE</div>
                    <div [class]="priceLabelClass" translate>PRINTERS.DETAIL.SCHEMA</div>
                </div>
                
                <div class="tw-col-span-full tw-bg-gray-300 tw-h-px tw-mt-2"></div>
            </div>

            <div class="tw-flex tw-flex-col tw-gap-1">
                @for(paymentMethod of paymentMethods; track paymentMethod.id; let isEven = $even) {
                    <div class="tw-grid tw-grid-cols-[1fr_3.5fr_1fr_1fr_2fr_1.5fr] tw-items-center tw-rounded tw-gap-x-3 tw-py-2 tw-min-w-0"
                        [class.tw-bg-[var(--sys-input-fill)]]="!isEven">
                        <div [class]="linearValueClass" class="break-words-auto">{{ paymentMethod.id }}</div>
                        <div [class]="linearValueClass" class="break-words-auto">{{ paymentMethod.name }}</div>
                        <div [class]="linearValueClass" class="break-words-auto">{{ paymentMethod.payment_method_type_id }}</div>
                        <div [class]="linearValueClass" class="break-words-auto" translate>{{ paymentMethod.unclaimed ? 'PRINTERS.DETAIL.YES' : 'PRINTERS.DETAIL.NO' }}</div>
                        <div [class]="linearValueClass" class="break-words-auto">{{ paymentMethod.bundle_name || '-' }}</div>
                        <div [class]="linearValueClass" class="break-words-auto">{{ paymentMethod.schema_name || '-' }}</div>
                    </div>
                }
            </div>
        </section>
    </app-card>
}